import React from 'react';

const SearchBox = ({ children, classNames = '' }) => (
  <div className={`searchBox min-w-95 sm:min-w-60 ${classNames}`}>
    {children}
  </div>
);

export default SearchBox;
